export default __webpack_public_path__ + "static/media/07.4c49c6e8.jpg";